export default __webpack_public_path__ + "static/media/ic_lock.54844460.svg";